<template>
    <div id="bloque_indicadores">
        <div class="jumbotron">
            <h1 id="titulo_bienvenido">Bienvenido {{ userlogged }}</h1>
            <div class="input-group mb-3">
                <!-- <i class="glyphicon glyphicon-search"></i> -->
                <input id="cedula_paciente" type="text" v-model="cedula_paciente" v-on:keyup.enter="consultar_paciente" class="form-control" placeholder="Ingrese el número de cédula del paciente"
                    aria-label="Recipient's username" aria-describedby="basic-addon2">
                <div class="input-group-append">
                    <button v-on:click="consultar_paciente" class="btn btn-outline-secondary" type="button">Buscar paciente</button>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 col-xs-12"  v-bind:class="{'encuesta_display' : encuesta_display}">
                    <div class="d-inline">
                        <h4>Paciente</h4>
                        <span> {{ nombre_paciente }} </span>
                    </div>
                    <div>
                        <h4>Seleccione el tipo de llamada</h4>
                        <div class="form-check-inline">
                            <label class="container" for="tipo_llamada_seguimiento">Seguimiento telefónico
                                <input id="tipo_llamada_seguimiento" v-model="tipo_llamada" type="radio" value="SEGUIMIENTO TELEFONICO" v-on:click="checkOnClick($event)">
                                <span class="checkmark"></span>
                            </label>
                            <label class="container" for="tipo_llamada_linea">Línea 7x24
                                <input id="tipo_llamada_linea" v-model="tipo_llamada" type="radio" value="LLAMADA LINEA 7x24" v-on:click="checkOnClick($event)">
                                <span class="checkmark"></span>
                            </label>
                        </div>                       
                    </div>
                </div>
                <div class="col-md-6 col-xs-12"  v-bind:class="{'encuesta_display' : encuesta_display}">
                    <h4>¿Quién se comunica?</h4>
                    <div class="form-check-inline">
                        <label class="container" for="comunica_paciente">Paciente
                            <input id="comunica_paciente" v-model="quien_se_comunica" type="radio" value="paciente">
                            <span class="checkmark"></span>
                        </label>
                        <label class="container" for="comunica_cuidador">Cuidador primario
                            <input id="comunica_cuidador" v-model="quien_se_comunica" type="radio" value="cuidador primario">
                            <span class="checkmark"></span>
                        </label>
                    </div>
                </div>
            </div>
            <br>
        </div>
        <div class="factores_riesgo" v-if="marcas_presentes">
            <div class="titulo_modulo">
                <h3>Marcas presentes en el paciente</h3>
            </div>
            <hr class="separate_module">
            <div class="row">
                <div class="col-md-6 col-xs-12">
                    <div v-bind:class="{'falla_cardiaca' : falla_cardiaca}" class="colum notice notice-danger">
                        <strong>Falla cardiaca</strong>
                        <p>El paciente presenta una patología cardiaca de alto riesgo</p>
                    </div>
                    <div v-bind:class="{'corticoides' : corticoides}" class="colum notice notice-danger">
                        <strong>Tratamiento corticoides</strong>
                        <p>Paciente con un tratamiento activo de corticoides</p>
                    </div>
                </div>
                <div class="col-md-6 col-xs-12">
                    <div v-bind:class="{'VEF1' : VEF1}" class="colum notice notice-danger">
                        <strong>VEF1</strong>
                        <p>La última espirometría realizada a este paciente tuvo un valor de <strong>VEF1 {{ marca_vef1 }}</strong></p>
                    </div>
                    <div v-bind:class="{'exacerbaciones' : exacerbaciones}" class="colum notice notice-danger">
                        <strong>Exacerbaciones elevadas</strong>
                        <p>El paciente ha presentado <strong>{{ marca_exacerbaciones }}</strong> exacerbaciones en el último año</p>
                    </div>
                </div>
            </div>
        </div>
    <div id="encuesta" v-bind:class="{'encuesta_display' : encuesta_display}" class="encuesta">
    <div class="titulo_modulo">
        <h3>Encuesta</h3>
    </div>
    <hr class="separate_module">
        <div class="alert alert-danger" v-if="resultado === 'Remitir a urgencias'">
            <h2>{{ resultado }}</h2>
        </div>
        <div class="alert alert-warning" v-else-if="resultado === 'Asignar cita prioritaria'">
            <h2>{{ resultado }}</h2>
        </div>
        <div class="alert alert-warning" v-else-if="resultado === 'Indicar cómo realizar el ciclo de rescate'">
            <h2>{{ resultado }}</h2>
        </div>
        <div class="alert alert-success" v-else-if="resultado === 'Adjuntar en observación el motivo de la llamada'">
            <h2>{{ resultado }}</h2>
        </div>
    <div class="card-group">
        <div class="col-md-3 col-xs-12">
            <div class="card card-pregunta">
                <h5 class="card-header"><strong>Aumento de tos</strong></h5>
                <div class="card-body">
                    <p class="card-text">El paciente manifiesta que la tos ha aumentado</p>
                    <br>
                    <div class="form-check-inline">
                        <label class="container" for="si_aumento_tos">Sí
                            <input id="si_aumento_tos" v-model="aumento_tos" true-value="Sí" false-value="No" type="radio" value=1>
                            <span class="checkmark"></span>
                        </label>
                        <label class="container" for="no_aumento_tos">No
                            <input id="no_aumento_tos" v-model="aumento_tos" true-value="Sí" false-value="No" type="radio" value=0>
                            <span class="checkmark"></span>
                        </label>
                    </div>
                    <!-- <h1>{{ aumento_tos }}</h1> -->
                </div>
            </div>
        </div>
        <div class="col-md-3 col-xs-12">
            <div class="card card-pregunta">
                <h5 class="card-header"><strong>Color de la flema</strong></h5>
                <div class="card-body">
                    <p class="card-text">El  paciente manifiesta que el color de la flema es más amarillo o verdoso de lo habitual</p>
                    <br>
                    <div class="form-check-inline">
                        <label class="container" for="si_flema_amarilla">Sí
                            <input id="si_flema_amarilla" v-model="flema_amarilla" true-value="Sí" false-value="No" type="radio" value=1>
                            <span class="checkmark"></span>
                        </label>
                        <label class="container" for="no_flema_amarilla">No
                            <input id="no_flema_amarilla" v-model="flema_amarilla" true-value="Sí" false-value="No" type="radio" value=0>
                            <span class="checkmark"></span>
                        </label>
                    </div>
                    <!-- <h1>{{ flema_amarilla }}</h1> -->
                </div>
            </div>
        </div>
        <div class="col-md-3 col-xs-12">
            <div class="card card-pregunta">
                <h5 class="card-header"><strong>Dificultad al respirar</strong></h5>
                <div class="card-body">
                    <p class="card-text">El paciente presenta mayor dificultad al respirar</p>
                    <br>
                    <div class="form-check-inline">
                        <label class="container" for="si_disnea">Sí
                            <input id="si_disnea" v-model="disnea_alta" true-value="Sí" false-value="No" type="radio" value=1>
                            <span class="checkmark"></span>
                        </label>
                        <label class="container" for="no_disnea">No
                            <input id="no_disnea" v-model="disnea_alta" true-value="Sí" false-value="No" type="radio" value=0>
                            <span class="checkmark"></span>
                        </label>
                    </div>
                    <!-- <h1>{{ disnea_alta }}</h1> -->
                </div>
            </div>
        </div>
        <div class="col-md-3 col-xs-12">
            <div class="card card-pregunta">
                <h5 class="card-header"><strong>Presión en el pecho</strong></h5>
                <div class="card-body">
                    <p class="card-text">El paciente indica que siente presión en el pecho</p>
                    <br>
                    <div class="form-check-inline">
                        <label for="si_presion_pecho" class="container">Sí
                            <input v-model="presenta_presion_pecho" id="si_presion_pecho" value=1 type="radio">
                            <span class="checkmark"></span>
                        </label>
                        <label for="no_presion_pecho" class="container">No
                            <input v-model="presenta_presion_pecho" id="no_presion_pecho" value=0 type="radio">
                            <span class="checkmark"></span>
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <br>

        <div class="form-group">
            <div class="titulo_modulo">
                <h3>Observación</h3>
            </div>
            <hr class="separate_module">            
            <textarea class="form-control" v-model="observacion" id="observacion" cols="50" rows="8"></textarea>
        </div>
        <div class="row">
            <div class="col-md-12 col-xs-12">
                <div class="card">
                    <h5 class="card-header"><strong>Marcaciones especiales</strong></h5>
                    <div class="card-body">
                        <p>En caso que el paciente manifieste no saber cómo usar el medicamento o, en caso que manifieste no tenerlo, realice la marcación respectiva</p>
                        <div class="row">
                            <div class="col-md-6 col-xs-12">
                                <div class="card-marcacion">
                                    <h5 class="card-header"><strong>Falta educación</strong></h5>
                                    <div class="card-body">
                                        <p class="card-text">El paciente sabe cómo usar el medicamento</p>
                                        <br>
                                        <div class="form-check-inline">
                                            <label class="container" for="si_falta_educacion">Sí
                                                <input id="si_falta_educacion" v-model="falta_educacion" true-value="Sí" false-value="No" type="radio" value="Sí">
                                                <span class="checkmark"></span>
                                            </label>
                                            <label class="container" for="no_falta_educacion">No
                                                <input id="no_falta_educacion" v-model="falta_educacion" true-value="Sí" false-value="No" type="radio" value="No">
                                                <span class="checkmark"></span>
                                            </label>                                             
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 col-xs-12">
                                <div class="card-marcacion">
                                    <h5 class="card-header"><strong>Falta medicamento</strong></h5>
                                    <div class="card-body">
                                        <p class="card-text">El paciente tiene el medicamento de rescate</p>
                                        <br>
                                        <div class="form-check-inline">
                                            <label class="container" for="si_falta_medicamento">Sí
                                                <input id="si_falta_medicamento" v-model="falta_medicamento" true-value="Sí" false-value="No" type="radio" value="Sí">
                                                <span class="checkmark"></span>
                                            </label>
                                            <label class="container" for="no_falta_medicamento">No
                                                <input id="no_falta_medicamento" v-model="falta_medicamento" true-value="Sí" false-value="No" type="radio" value="No">
                                                <span class="checkmark"></span>
                                            </label>                                             
                                        </div>
                                    </div>
                                </div>
                            </div>                          
                        </div>                  
                    </div>
                </div>
            </div>            
        </div>
        <div class="wrapper">
            <br>
            <div class="form-group" v-show="tipo_llamada == 'LLAMADA LINEA 7x24'">
                <label for="linea7x24"> Seleccione el motivo de la llamada</label>
                <select v-model="resultado_linea7x24">
                    <option v-for="option in listado_linea7x24" v-bind:key="option.code">
                        {{ option.code_text }}
                    </option>
                </select>
            </div>
            <button v-on:click="enviar_encuesta" type="button" class="btn-success">enviar encuesta</button>
        </div>
        <br>
        </div>
        <div v-if="resultado === 'Indicar cómo realizar el ciclo de rescate'"
            class="row">
            <div class="column" style="background-color:#aaa;">
                <h5>
                    Ciclo rescate inhalador
                </h5>
                <span>
                    Paso 1: realice 2 inhalaciones cada 20 minutos durante 1 hora Paso 2: realice 2 inhalaciones cada 2 horas por 4 horas Paso
                    3: realice 2 inhalaciones cada 6 horas por 3 días
                </span>
            </div>
            <div class="column" style="background-color:#bbb;">
                <h5>
                    Ciclo rescate nebulizador
                </h5>
                <span>
                    Paso 1: realice 2 inhalaciones cada 20 minutos durante 1 hora Paso 2: realice 2 inhalaciones cada 2 horas por 4 horas Paso
                    3: realice 2 inhalaciones cada 6 horas por 3 días
                </span>
            </div>
        </div>
    </div>    
</template>

<script>
import { serverBus } from '../main'
import redes from '../js/redes'
import axios from '../apiService/config/axios';

export default {
    name:'soporte-linea7x24',
    computed:{
        userlogged: function() {
            return this.$store.state.userlogged;
        },
        provider_id: function(){
            return this.$store.state.provider_id;
        }
    },
    data() {
        return{
        cedula_paciente: '',
        falla_cardiaca: true,
        corticoides: true,
        VEF1: true,
        exacerbaciones: true,
        encuesta_display: true,
        disnea_alta: '',
        aumento_tos: '',
        presenta_presion_pecho:'',
        pid:'',
        marca_falla_cardiaca:'',
        marca_exacerbaciones:'',
        marca_vef1:100,
        marca_corticoides:'',
        observacion:'',
        flema_amarilla:'',
        falta_educacion:'',
        falta_medicamento:'',
        marcas_presentes:false,
        nombre_paciente:'',
        quien_se_comunica:'',
        resultado:'',
        resultado_llamada:'',
        json_openemr:null,
        listado_linea7x24:[],
        resultado_linea7x24:'',
        code_selected:'',
        tipo_llamada:'',
        reason_call:'',
        }
    },
    beforeCreate(){
        console.log("Before create called")
    },
    create(){
        console.log("create called")
    },
    beforeMount(){
        console.log("Before mount called")
    },
    mounted(){
        console.log("mounted called")
        console.log("user", this.userlogged)
        console.log("provider_id", this.provider_id)
    },
    beforeUpdate(){

        this.listado_linea7x24.forEach(element => {
            if(element.code_text == this.resultado_linea7x24){
                this.code_selected = "(" + element.code + ")"
            }

        });

        if(this.falla_cardiaca === true && this.corticoides === true && this.VEF1 === true && this.exacerbaciones === true){
            this.remision_urgencias = false;
            console.log("Before update sin marcas",this.resultado)
            if(this.disnea_alta != '' && this.aumento_tos != '' && this.presenta_presion_pecho != '' && this.flema_amarilla != ''){
                var resultado_red = [];
                console.log("Resultado en encuesta", this.resultado)
                resultado_red = (redes.logica_marcaciones([this.disnea_alta,this.aumento_tos,this.presenta_presion_pecho,this.flema_amarilla]))

                if(resultado_red.indexOf(Math.max(...resultado_red)) === 0){
                    this.resultado = "Adjuntar en observación el motivo de la llamada"
                    this.resultado_llamada = "Paciente no presenta síntomas negativos"
                } else if(resultado_red.indexOf(Math.max(...resultado_red)) === 1){
                    this.resultado = "Asignar cita prioritaria"
                    this.resultado_llamada = "Paciente requiere cita prioritaria"
                } else if(resultado_red.indexOf(Math.max(...resultado_red)) === 2){
                    this.resultado = "Indicar cómo realizar el ciclo de rescate"
                    this.resultado_llamada = "Paciente requiere ciclo de rescate"
                } else if(resultado_red.indexOf(Math.max(...resultado_red)) === 3){
                    this.resultado = "Remitir a urgencias"
                    this.resultado_llamada = "Paciente es remitido a urgencias"
                }
            }
        }else{
            this.resultado_llamada = "Paciente es remitido a urgencias"
        }
    
    },
    updated() {

    },
    methods: {
        checkOnClick: function(event){
            
            console.log("crearlista",event.currentTarget.value, this.tipo_llamada)
            if(event.currentTarget.value == 'LLAMADA LINEA 7x24'){
                //Crear lista desplegable para motivo de llamada
                this.crearlista_linea7x24()
            }
        },
        consultar_paciente: function () {
            console.log("Consultar paciente", this.resultado)
            this.disnea_alta = '';
            this.aumento_tos = '';
            this.presenta_presion_pecho = '';
            this.flema_amarilla = '';
            this.falta_educacion = '';
            this.falta_medicamento = '';
            this.marcas_presentes = false;
            this.resultado = '';
            // this.$store.state.userloged = this.userloged
            axios.post('/apoyo_7x24_backend/marcaciones',{
                cedula_paciente: this.cedula_paciente
            })
            // .then(response => this.success_login(response))
            .then(response => this.success_login(response))
            .catch((error) => {                 
            console.log("error_marcaciones",error)
            this.failed_login()
            })
        },

        success_login (response){
            this.encuesta_display = false;
            this.pid=response.data.data.marcas[0].pid;
            this.marca_falla_cardiaca=response.data.data.marcas[0].falla_cardiaca;
            this.marca_exacerbaciones=response.data.data.marcas[0].numero_exacerbaciones;
            this.marca_corticoides = response.data.data.marcas[0].corticoides_prolongados;
            this.nombre_paciente = response.data.data.marcas[0].Nombre_Paciente;

            if( response.data.data.marcas[1] == null){
                this.VEF1 = true;
            }else{
                this.marca_vef1=response.data.data.marcas[1].FEV1;
                if(response.data.data.marcas[1].FEV1 <= 30){
                    this.VEF1 = false
                }else{
                    this.VEF1 = true
                }
            }

            if(this.marca_falla_cardiaca != 0 || this.marca_exacerbaciones >= 4 || this.marca_corticoides != null || this.marca_vef1 <= 30){
                this.marcas_presentes = true;
                this.resultado = "Remitir a urgencias"
                console.log("Urgencias")
            }else{
                this.marcas_presentes = false;
            }

            if (response.data.data.marcas[0].falla_cardiaca == 1) {
            this.falla_cardiaca = false;
            } else {
                this.falla_cardiaca = true;
            }
            if (response.data.data.marcas[0].numero_exacerbaciones >= 3) {
                this.exacerbaciones = false;
            } else {
                this.exacerbaciones = true;
            }if (response.data.data.marcas[0].corticoides_prolongados >= 1) {
                this.corticoides = false;
            } else {
                this.corticoides = true;
            }

        },
        failed_login(){
            console.log(Error)
            this.encuesta_display=true;
            this.exacerbaciones = true;
            this.falla_cardiaca = true;
            this.corticoides = true;
            this.VEF1 = true;
            alert("Paciente no registrado o, no se encuentra en el programa")

        },
        enviar_encuesta(event){
            
            if(event){
                if(this.disnea_alta === '' || this.aumento_tos === '' || this.presenta_presion_pecho === '' || this.flema_amarilla === '' ){
                    alert("Completa la encuesta por favor")
                }else{
                if(this.tipo_llamada == 'LLAMADA LINEA 7x24'){
                    this.insert_llamada7x24();
                }
                this.registro_openemr();
                axios.post('/registro_llamada/registrar',{
                    usuario:this.userlogged,
                    pid:this.pid,
                    pubpid:this.cedula_paciente,
                    marca_falla_cardiaca:this.marca_falla_cardiaca,
                    marca_exacerbaciones:this.marca_exacerbaciones,
                    marca_vef1:this.marca_vef1,
                    marca_corticoides:this.marca_corticoides,
                    respuesta_disnea:this.disnea_alta,
                    respuesta_aumento_tos:this.aumento_tos,
                    respuesta_presion_pecho:this.presenta_presion_pecho,
                    respuesta_flema:this.flema_amarilla,
                    resultado_llamada:this.resultado_llamada,
                    marca_falta_educacion:this.falta_educacion,
                    marca_falta_medicamento:this.falta_medicamento,
                    canal_de_contacto:"WEB",
                    observacion:this.observacion
                })
                .then((response) => {
                alert("Encuesta enviada con éxito")
                location.reload()
                })
                .catch((error) => console.log("error: " + error))
                }
            }

        },
        registro_openemr(){
            // this.json_openemr = 
            // {
            //     reason:"El resultado del algoritmo fue, respuesta a mas tos: " + this.respuestas_strings(this.aumento_tos) + ", respuesta a flema amarilla: " + this.respuestas_strings(this.flema_amarilla) + ", respuesta a disnea: " + this.respuestas_strings(this.disnea_alta) + ", respuesta presión en pecho: " + this.respuestas_strings(this.presenta_presion_pecho),
            //     pid:48962,
            //     pc_catid:64,
            //     provider_id:this.provider_id,
            //     user:this.userlogged,
            //     reason_procedure_order:"Se comunica el " + this.quien_se_comunica + " el día " + new Date().toLocaleString() + ", el resultado de la llamada fue: " + this.resultado_llamada + " La observación realizada respecto a la llamada fue: " + this.observacion
            // }
            axios.post('/update_openemr/insert/llamada_7x24',
                {
                    reason_procedure_order:"El resultado del algoritmo fue, respuesta a mas tos: " + this.respuestas_strings(this.aumento_tos) + ", respuesta a flema amarilla: " + this.respuestas_strings(this.flema_amarilla) + ", respuesta a disnea: " + this.respuestas_strings(this.disnea_alta) + ", respuesta presión en pecho: " + this.respuestas_strings(this.presenta_presion_pecho),
                    pid:this.pid,
                    pc_catid:64,
                    provider_id:this.provider_id,
                    user:this.userlogged,
                    reason: this.tipo_llamada + ", se comunica el " + this.quien_se_comunica + " el día " + new Date().toLocaleString() + ", el resultado de la llamada fue: " + this.resultado_llamada + " La observación realizada respecto a la llamada fue: " + this.observacion
                }).then((response) =>{

                }).catch((error) => {
                    alert("Se ha presentado un error, por favor intente más tarde")
                })
        },
        respuestas_strings(respuesta){
            console.log("respuesta", respuesta)
            if(respuesta == 0){
                return "No"
            }else{
                return "Sí"
            }
        },
        crearlista_linea7x24(){
            axios.get('/update_openemr/get/listado_linea7x24')
            .then((response) =>{
                this.listado_linea7x24 = response.data.data.listado
                console.log("listado", this.listado_linea7x24)
            })
            .catch((error) =>{
                console.log("listado error", error)
            })
        },
        insert_llamada7x24(){
            axios.post('/update_openemr/insert/llamada_linea_7x24',{
                result: this.resultado_linea7x24,
                diagnosis: "LLAMADA LINEA 7X24" + this.code_selected,
                pid:this.pid 
            })
            .then((response) => {

            })
            .catch((error) => {
                alert("Se ha presentado un error, por favor intente más tarde") 
            })
        }
    }
}
</script>

<style scoped>
.form-check-inline{
    display: flex;
    flex-wrap: wrap;
}
* {
    box-sizing: border-box;
    font-family: 'Nunito'
}

.d-inline h4,span{
    display: inline-block;
}

.jumbotron{
    background-color: #959595;
    background: linear-gradient(to bottom, rgba(208, 215, 237) , rgba(208, 215, 237, 1)); 
    margin-bottom: 0px;
    padding-bottom: 0px;
}

#cedula_paciente{
    border-color: #2b292f;
    border-width: 1.5px;
}

#titulo_bienvenido{
    color: #2b292f;
}

.titulo_modulo{
   text-align: center;

}

.titulo_modulo h3{
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    color: #2c3e50;
    font-weight: bold;
}

.separate_module{
    height: 12px;
    border: 0;
    box-shadow: inset 0 12px 12px -12px rgba(0, 0, 0, 0.5);
}

p{
    font-size: 18px;
}

body {
    font-family: Arial, Helvetica, sans-serif;
}

.falla_cardiaca{
    display: none;
}

.exacerbaciones{
    display: none;
}

.VEF1{
    display: none;
}

.corticoides{
    display: none;
}

.encuesta_display{
    display: none;
}

.warning_color{
    background-color: #ff9900;
}

.alert_color{
    background-color: #ff0000;
}

.success_color{
    background-color: #33cc33;
}

.wrapper{
    text-align: center;
}

.btn-success{
    padding: 4px;
    margin-top: 16px;
    position: static;
    right: 50%;
}

.notice {
    padding: 15px;
    background-color: #fafafa;
    border-left: solid #7f7f84;
    margin-bottom: 10px;
    margin-left: 10px;
    -webkit-box-shadow: 0 5px 8px -6px rgba(0,0,0,.2);
       -moz-box-shadow: 0 5px 8px -6px rgba(0,0,0,.2);
            box-shadow: 0 5px 8px -6px rgba(0,0,0,.2);
}

.notice-danger {
    border-color: #d73814;
}

/* Style the header */
/* .header {
    background-color: #f1f1f1;
    padding: 30px;
    text-align: center;
    font-size: 25px;
} */
.factores_riesgo {
    background-color: #f1f1f1;
    padding: 30px;
    font-size: 25px;
}

.encuesta {
    background-color: #f1f1f1;
    padding: 30px;
    font-size: 25px;
}

.alerta_urgencias {
    background-color: #f1f1f1;
    padding: 30px;
    text-align: center;
    font-size: 25px;
}

/* Container for flexboxes */
.row {
    display: -webkit-flex;
    display: flex;
}

/* Create three equal columns that sits next to each other */
.column {
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    padding: 5px;
    margin-right: 10px;
    /* height: 150px;  */
}

.column_answers{
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    padding: 10px;
    /* height: 150px;  */
}

/* Style the footer */
.footer {
    background-color: #f1f1f1;
    padding: 10px;
    text-align: center;
}

.titulo_cedula{
    font-size: 15px;
}

.card-pregunta{
    height: 350px;
}

.card-marcaciones{
    height: 150px;
}

.border{
    margin-top: 15px;
    background-color: #ffffff;
}

.card-header{
    font-size: 20px;
    text-align: center

}

/* enable absolute positioning */
.inner-addon { 
    position: relative; 
}

/* style icon */
.inner-addon .glyphicon {
  position: absolute;
  padding: 10px;
  pointer-events: none;
}

/* align icon */
.right-addon .glyphicon { right: 20px;}
.right-addon .glyphicon { top: 25px;}


/* add padding  */
.right-addon input { padding-right: 30px; }

.container {
    display: block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

/* Hide the browser's default checkbox */
.container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
}

/* Create a custom checkbox */
.checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 25px;
    width: 25px;
    background-color: #eee;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
    background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
    background-color: #2196F3;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
    content: "";
    position: absolute;
    display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
    display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
    left: 9px;
    top: 5px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
}

/* Responsive layout - makes the three columns stack on top of each other instead of next to each other */
@media (max-width: 600px) {
    .row {
      -webkit-flex-direction: column;
      flex-direction: column;
    }
}
</style>





// WEBPACK FOOTER //
// src/components/Soporte_linea7x24.vue